/* eslint-disable linebreak-style */
import React from 'react';

const oneinchIcon = (
    fill: string,
    size: number,
    style?: React.CSSProperties,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size / 1.0605}
        viewBox="0 0 24 22.63"
        style={style}
    >
        <title>oneinch icon</title>
        <g
            id="_1inch-1inch-logo"
            data-name="1inch-1inch-logo"
            transform="translate(0.099 0.01)"
        >
            <path
                id="Path_126"
                data-name="Path 126"
                d="M29.571,42.027l.635-4.78L24.7,33.417l5.03,1.708L30.918,33.3l4.338-2.7,9.562,5.28.5,8.056-4.26,5.933-3.367.517,1.741-3.194V44.116l-1.266-2.4-1.286-.854L34.9,42.9v2.164l-1.544,1.449-1.962.238-.869.493L29.1,46.793,28.5,44.65l1.069-1.507Z"
                transform="translate(-23.955 -29.569)"
                fill="#fff"
            />
            <path
                id="Path_127"
                data-name="Path 127"
                d="M287.519,107.462a10.042,10.042,0,0,0-2.2-.16,3.216,3.216,0,0,1-2.718,2.2A4.207,4.207,0,0,0,287.519,107.462Z"
                transform="translate(-273.104 -103.655)"
                fill="#94a6c3"
            />
            <path
                id="Path_128"
                data-name="Path 128"
                d="M186.464,182.227a7.652,7.652,0,0,0,2.66-3.909c.02-.058.2-.16.316-.238.2-.119.4-.218.435-.378a8.372,8.372,0,0,0,.119-1.408c0-.177-.18-.357-.357-.534-.139-.119-.279-.259-.279-.357A7.542,7.542,0,0,0,187,170.681l-.139.139a7.405,7.405,0,0,1,2.3,4.6,1.007,1.007,0,0,0,.337.476c.139.119.3.3.3.378a8.074,8.074,0,0,1-.119,1.368c-.02.078-.2.16-.337.238-.2.1-.378.2-.415.357a7.336,7.336,0,0,1-3.017,4.11c.259-.555,1.072-2.361,1.507-3.276l-.078-2.936-2.521-2.439-1.429.2-1.568,2.541a1.521,1.521,0,0,1-.3,2.024,4.7,4.7,0,0,1-1.806,1.31l-.735-.4a7.737,7.737,0,0,1,.993-.973c.575-.476,1.15-.517,1.15-1.031.024-1.075-1.129-.779-1.129-.779l-.418.4-.177,1.47-.871,1.092-.1-.02L177,179.213s.874-.456,1.014-.973a7.993,7.993,0,0,0-.3-2.242,2.164,2.164,0,0,1,.6.912,7.206,7.206,0,0,1,.854-1.786c.119-.078,1.725-.932,1.725-.932l-.534,1.408.4-.218.953-2.341a4.67,4.67,0,0,1,1.626-.456c1.249-.02,3.1-1.548,2.262-4.286.238.1,4.365,2.164,5.079,6.212C191.206,177.625,189.441,180.54,186.464,182.227Z"
                transform="translate(-171.101 -162.584)"
                fill="#94a6c3"
            />
            <path
                id="Path_129"
                data-name="Path 129"
                d="M286.534,87.23a1.7,1.7,0,0,0,.279-1.33l-1.33,1.966A1.539,1.539,0,0,0,286.534,87.23Z"
                transform="translate(-275.885 -82.988)"
                fill="#1b314f"
            />
            <path
                id="Path_130"
                data-name="Path 130"
                d="M168.864,418.093l.16-.793s-.657,1.15-.714,1.31c-.061.18.041.5.3.476a.789.789,0,0,0,.575-.674A.284.284,0,0,0,168.864,418.093Z"
                transform="translate(-162.673 -403.114)"
                fill="#1b314f"
            />
            <path
                id="Path_131"
                data-name="Path 131"
                d="M17.955,2.358s.991.041,2.02.16a10.041,10.041,0,0,0-6.3-2.361A8.6,8.6,0,0,0,9.456,1.229L10.23,0a4.112,4.112,0,0,0-4.18,2.977,16.334,16.334,0,0,1-.533-1.708,3.592,3.592,0,0,0-.852,3.752C2.821,4.345.19,3.409.088,3.392c-.139-.02-.18.041-.18.041s-.041.058.078.16c.221.173,4.38,3.252,5.293,3.848-.2.714-.2,1.051,0,1.388a1.386,1.386,0,0,1,.258,1.031c-.041.337-.4,3.256-.475,3.613s-.91,1.626-.873,2,.553,1.983,1.012,2.164a6.348,6.348,0,0,0,1.721.378.7.7,0,0,0,.455-.119c.336-.3.435-.357.672-.357h.058c.1,0,.217.02.357.02a1.5,1.5,0,0,0,1.029-.337c.435-.435,1.188-1.031,1.426-1.31a1.845,1.845,0,0,0,.377-1.408,1.889,1.889,0,0,1,.5-1.31c.377-.5,1.07-1.388,1.07-1.388a5.419,5.419,0,0,1,2.221,4.341,5.815,5.815,0,0,1-6.02,5.6,6.361,6.361,0,0,1-1.5-.177,11.664,11.664,0,0,0,3.864.714,6.428,6.428,0,0,0,3.426-.813,9.88,9.88,0,0,1-1.09,1.15h.02a8.115,8.115,0,0,0,5.507-3.572s-.139.993-.316,1.667C23.9,17,23.065,12.36,23.045,12.2c.041.058.536.653.791.973A10.276,10.276,0,0,0,17.955,2.358Zm-7.585,13.06c-.078.1-.414.4-.652.616s-.5.435-.693.636a.691.691,0,0,1-.475.119H7.955a10.53,10.53,0,0,1,1.467-1.507c.357-.238.536-.476.316-.891s-.791-.316-.791-.316a1.963,1.963,0,0,1,.635-.139,1.221,1.221,0,0,0-1.07.218c-.238.218-.2.993-.3,1.487-.1.517-.435.776-.951,1.252a.978.978,0,0,1-.635.337,6.755,6.755,0,0,1-1.012-.259,5.685,5.685,0,0,1-.574-1.47,8.064,8.064,0,0,1,.414-.854,3.742,3.742,0,0,0,.418-.953c.078-.337.336-2.422.435-3.293.258.337.615.895.533,1.252A1.678,1.678,0,0,0,6.8,9.726,2.188,2.188,0,0,1,6.587,8.1c.2-.674.91-2.541.91-2.541s.238.418.574.337A39.472,39.472,0,0,0,11.12,1.729a3.228,3.228,0,0,1-.041,2.779A3.265,3.265,0,0,1,9.514,5.9a2.961,2.961,0,0,0,2.1-.538c.414.973.812,1.983.832,2.123-.061.139-.852,2.045-.93,2.164A1.978,1.978,0,0,1,11,9.8a2.8,2.8,0,0,0-.615.218,22.181,22.181,0,0,0-1.07,2.718,1.644,1.644,0,0,0-.971.694,2.8,2.8,0,0,1,.893-.2,1.777,1.777,0,0,1,1.348,1.289v.041A1.228,1.228,0,0,1,10.369,15.418Zm-1.861.238a1.845,1.845,0,0,0,.18-.833c.02-.139.058-.4.217-.435s.536.02.536.3c0,.259-.278.316-.475.5C8.825,15.316,8.546,15.615,8.509,15.656Zm7.9-3.793a9.544,9.544,0,0,0,.16-2.6,7.3,7.3,0,0,1,1.385,3.572,1.007,1.007,0,0,0,.336.476c.139.119.3.279.3.378a8.158,8.158,0,0,1-.119,1.371c-.02.058-.2.16-.336.238-.2.1-.377.2-.414.357a7.4,7.4,0,0,1-2.614,3.831C16.946,17.561,17.836,14.384,16.41,11.863Zm-1.246,7.8a7.637,7.637,0,0,0,2.713-3.95c.02-.058.2-.16.316-.238.2-.1.4-.218.435-.378a8.387,8.387,0,0,0,.119-1.408c0-.177-.18-.357-.357-.534-.1-.119-.258-.259-.258-.357a7.79,7.79,0,0,0-1.623-3.95,4.1,4.1,0,0,0-2.02-3.137,3.642,3.642,0,0,1,.357,3.293,2.65,2.65,0,0,1-2.774,1.507,6.452,6.452,0,0,0-1.545,2.262,2.134,2.134,0,0,0-.991-.058c.357-.993.893-2.4.991-2.521a3.016,3.016,0,0,1,.536-.177c.377-.1.553-.16.615-.238.041-.061.238-.517.435-.993a4.463,4.463,0,0,0,.672-.061A7.4,7.4,0,0,0,13.2,7.6c0-.1-.774-2.024-1.07-2.759a4.575,4.575,0,0,0,.414-.575,8.123,8.123,0,0,1,2.618,15.4Z"
                transform="translate(0 0)"
                fill="#1b314f"
            />
            <path
                id="Path_132"
                data-name="Path 132"
                d="M216.86,188.436a.866.866,0,0,0-.517-1.388c.18-.415.435-1.248.435-1.248s-2.024,3.174-2.2,3.235-.357-.636-.357-.636c-.378,1.449.636,1.647.755,1.191A5.077,5.077,0,0,0,216.86,188.436Z"
                transform="translate(-206.962 -179.489)"
                fill="#1b314f"
            />
            <path
                id="Path_133"
                data-name="Path 133"
                d="M243.4,235.866l1.031-1.766s.6.3.3.776A3.85,3.85,0,0,1,243.4,235.866Z"
                transform="translate(-235.232 -226.146)"
                fill={fill || '#ffd923'}
            />
            <path
                id="Path_134"
                data-name="Path 134"
                d="M589.231,288.093A11.624,11.624,0,0,1,588.2,289.3a10.662,10.662,0,0,0,.02-9.6c.18.18.357.378.517.555A6.282,6.282,0,0,1,589.231,288.093Z"
                transform="translate(-568.331 -270.195)"
                fill={fill || '#d82122'}
            />
            <path
                id="Path_135"
                data-name="Path 135"
                d="M383.057,98.412a11.925,11.925,0,0,0-4.96-6.29,10.093,10.093,0,0,0-5.756-1.626H372.3a1.361,1.361,0,0,1,.3-.078,12.68,12.68,0,0,1,2.2-.456,6.529,6.529,0,0,1,5.678,1.943l.041.041A9.327,9.327,0,0,1,383.057,98.412Z"
                transform="translate(-359.776 -86.845)"
                fill={fill || '#d82122'}
            />
            <path
                id="Path_136"
                data-name="Path 136"
                d="M276.129,22.81a11.293,11.293,0,0,0-6.232.238,5.891,5.891,0,0,0-.3-.735c-.412.5-.85,1.092-1.126,1.47A4.032,4.032,0,0,0,267.4,24.8a4.136,4.136,0,0,1,3.256-2.878,8.088,8.088,0,0,1,1.429-.119A9.342,9.342,0,0,1,276.129,22.81Z"
                transform="translate(-258.426 -21.068)"
                fill={fill || '#d82122'}
            />
            <path
                id="Path_137"
                data-name="Path 137"
                d="M155.391,80.136c-2.32-.078-1.548-2.779-1.507-2.936C153.884,77.22,154.04,79.323,155.391,80.136Z"
                transform="translate(-148.604 -74.583)"
                fill={fill || '#d82122'}
            />
            <path
                id="Path_138"
                data-name="Path 138"
                d="M214.235,20.6c-1.786,1.072-1.429,3.63-1.429,3.63C211.1,21.634,214.1,20.661,214.235,20.6Z"
                transform="translate(-205.171 -19.909)"
                fill={fill || '#d82122'}
            />
            <path
                id="Path_139"
                data-name="Path 139"
                d="M91.535,149.628a.4.4,0,0,1,.1.538c-.078.139-.2.119-.378.041-.238-.119-1.667-.953-2.956-1.806,1.47.517,2.956,1.072,3.194,1.191C91.494,149.591,91.515,149.611,91.535,149.628Z"
                transform="translate(-85.391 -143.361)"
                fill="#fff"
            />
        </g>
    </svg>
);
export default oneinchIcon;
